/**
 * SavvyTot cart drawer + PDP upsells
 * Plain ES module — no @theme/ imports.
 */
(function () {
  if (window.__stUpsellsLoaded) return;
  window.__stUpsellsLoaded = true;

  const CART_EVENT = 'shopify:cart:lines-update';
  const SECTION_ID = 'cart-drawer-section';
  const TRUST = '#5B9BD5';

  const HANDLES = {
    sample: 'free-sample-pack',
    daily: 'daily-practice-screen-free-10-day',
    ninjas: 'number-ninjas-addition',
    wizards: 'word-wizards-phonics',
    bundle: 'screen-free-starter-bundle',
  };

  const COMPONENT_SET = new Set([
    HANDLES.daily,
    HANDLES.ninjas,
    HANDLES.wizards,
  ]);

  /** @type {any} */
  let CONFIG = null;
  /** @type {any} */
  let cartCache = null;
  let pendingBumpIds = [];
  let bumpInFlight = false;
  let stylesInjected = false;

  function readConfig() {
    if (CONFIG) return CONFIG;
    const el = document.getElementById('st-upsells-config');
    if (!el) return null;
    try {
      CONFIG = JSON.parse(el.textContent || '{}');
    } catch (e) {
      console.warn('[st-upsells] bad config', e);
      CONFIG = null;
    }
    return CONFIG;
  }

  function cat(handle) {
    const c = readConfig();
    return c && c.catalog ? c.catalog[handle] : null;
  }

  function itemHandle(item) {
    return (
      item.handle ||
      item.product_handle ||
      (item.url && String(item.url).split('/products/')[1]?.split('?')[0]?.split('/')[0]) ||
      ''
    );
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    cartCache = await res.json();
    return cartCache;
  }

  function handlesInCart(cart) {
    const set = new Set();
    (cart?.items || []).forEach((it) => {
      const h = itemHandle(it);
      if (h) set.add(h);
    });
    return set;
  }

  function hasTeOnly(cart) {
    const set = handlesInCart(cart);
    const hasTe = [...set].some((h) => h.includes('theme-explorers'));
    const hasComponent = [...COMPONENT_SET, HANDLES.bundle].some((h) => set.has(h));
    return hasTe && !hasComponent;
  }

  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;
    const css = `
.st-upsell{font-family:inherit;color:inherit;--st-blue:${TRUST};}
.st-upsell *{box-sizing:border-box;}
.st-upsell__heading{font-size:0.95rem;font-weight:600;margin:0 0 0.35rem;letter-spacing:0.01em;}
.st-upsell__sub{font-size:0.8rem;opacity:0.75;margin:0 0 0.75rem;line-height:1.35;}
.st-upsell__cards{display:grid;gap:0.65rem;width:100%;}
.st-upsell__card{display:flex;flex-direction:column;gap:0.4rem;padding:0.85rem 0.9rem;border:1px solid rgba(91,155,213,0.35);border-radius:10px;background:#fff;text-align:left;}
.st-upsell__card-title{font-size:0.92rem;font-weight:600;color:inherit;text-decoration:none;line-height:1.3;}
.st-upsell__card-title:hover{color:var(--st-blue);}
.st-upsell__card-price{font-size:0.85rem;opacity:0.85;}
.st-upsell__btn{appearance:none;border:none;cursor:pointer;min-height:44px;padding:0.55rem 0.9rem;border-radius:8px;font-size:0.9rem;font-weight:600;background:var(--st-blue);color:#fff;width:100%;transition:opacity .15s ease;}
.st-upsell__btn:hover{opacity:0.92;}
.st-upsell__btn:disabled{opacity:0.55;cursor:wait;}
.st-upsell__btn--outline{background:transparent;color:var(--st-blue);border:1.5px solid var(--st-blue);}
.st-upsell__row{display:flex;align-items:center;justify-content:space-between;gap:0.6rem;padding:0.55rem 0;border-bottom:1px solid rgba(0,0,0,0.06);}
.st-upsell__row:last-child{border-bottom:none;}
.st-upsell__row-meta{flex:1;min-width:0;}
.st-upsell__row-title{font-size:0.88rem;font-weight:560;line-height:1.3;}
.st-upsell__row-price{font-size:0.8rem;opacity:0.8;}
.st-upsell__row .st-upsell__btn{width:auto;min-width:72px;padding-inline:0.85rem;}
.st-upsell--empty{margin:0.75rem 0 1rem;width:100%;max-width:22rem;text-align:left;}
.st-upsell--cart{margin:0.5rem 0 0.85rem;padding:0.75rem 0 0;border-top:1px solid rgba(0,0,0,0.08);}
.st-upsell--upgrade{margin:0.65rem 0 0.25rem;padding:0.85rem 0.9rem;border:1.5px solid var(--st-blue);border-radius:10px;background:rgba(91,155,213,0.06);}
.st-upsell--upgrade .st-upsell__btn{margin-top:0.5rem;}
.st-upsell--pdp{margin:0 0 0.85rem;padding:0.75rem 0.85rem;border:1px solid rgba(91,155,213,0.3);border-radius:10px;background:rgba(91,155,213,0.05);}
.st-upsell__check{display:flex;align-items:flex-start;gap:0.55rem;min-height:44px;padding:0.25rem 0;cursor:pointer;font-size:0.9rem;line-height:1.35;}
.st-upsell__check input{width:18px;height:18px;margin-top:0.15rem;accent-color:var(--st-blue);flex-shrink:0;}
.st-upsell__soft{font-size:0.85rem;line-height:1.4;margin:0;}
.st-upsell__soft a{color:var(--st-blue);text-decoration:underline;text-underline-offset:2px;}
.st-upsell__continue{display:inline-block;margin-top:0.75rem;font-size:0.82rem;opacity:0.7;color:inherit;text-decoration:underline;text-underline-offset:2px;}
@media (max-width:749px){
  .st-upsell__cards{grid-template-columns:1fr;}
  .st-upsell__card{padding:0.75rem;}
}
`;
    const style = document.createElement('style');
    style.id = 'st-upsells-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function openCartDrawer() {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (_) {}
    }
    const btn =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('.header-actions__cart-icon, cart-icon, [data-testid="cart-icon"]');
    if (btn) btn.click();
  }

  function replaceCartSection(html) {
    if (!html) return false;
    const existing = document.getElementById(`shopify-section-${SECTION_ID}`);
    if (!existing) return false;
    const tmp = document.createElement('div');
    tmp.innerHTML = html.trim();
    const next = tmp.firstElementChild;
    if (!next) return false;
    existing.replaceWith(next);
    // Re-bind after morph — mounts are new DOM
    queueMicrotask(() => {
      renderAll(cartCache);
    });
    return true;
  }

  async function refreshSectionFallback() {
    try {
      const url = `/?sections=${SECTION_ID}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      const data = await res.json();
      if (data[SECTION_ID]) replaceCartSection(data[SECTION_ID]);
    } catch (e) {
      console.warn('[st-upsells] section refresh failed', e);
    }
  }

  async function addVariant(variantId, { open = true } = {}) {
    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: SECTION_ID,
      sections_url: window.location.pathname,
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.description || data?.message || 'Add failed');
    if (data.sections && data.sections[SECTION_ID]) {
      replaceCartSection(data.sections[SECTION_ID]);
    } else {
      await refreshSectionFallback();
    }
    await fetchCart();
    if (open) openCartDrawer();
    renderAll(cartCache);
    return data;
  }

  async function changeLineQty(key, quantity) {
    const body = {
      id: key,
      quantity,
      sections: SECTION_ID,
      sections_url: window.location.pathname,
    };
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.description || data?.message || 'Change failed');
    return data;
  }

  async function upgradeToBundle() {
    const cart = cartCache || (await fetchCart());
    const toRemove = (cart.items || []).filter((it) => COMPONENT_SET.has(itemHandle(it)));
    // Remove components one by one (qty 0), keep TE + sample
    let last = null;
    for (const it of toRemove) {
      last = await changeLineQty(it.key, 0);
    }
    if (last?.sections?.[SECTION_ID]) {
      replaceCartSection(last.sections[SECTION_ID]);
    }
    const bundle = cat(HANDLES.bundle);
    if (!bundle) throw new Error('Bundle config missing');
    await addVariant(bundle.variantId, { open: true });
  }

  function renderEmptyCards(root, cart) {
    if (!root) return;
    injectStyles();
    const empty = !cart || !cart.item_count;
    if (!empty) {
      root.innerHTML = '';
      root.hidden = true;
      return;
    }
    root.hidden = false;
    const handles = [HANDLES.sample, HANDLES.daily, HANDLES.bundle];
    const cards = handles
      .map((h) => {
        const p = cat(h);
        if (!p) return '';
        return `<article class="st-upsell__card">
          <a class="st-upsell__card-title" href="${p.url}">${p.title}</a>
          <div class="st-upsell__card-price">${p.priceDisplay}</div>
          <button type="button" class="st-upsell__btn" data-st-add="${p.variantId}">${p.addLabel || 'Add'}</button>
        </article>`;
      })
      .join('');
    root.innerHTML = `<div class="st-upsell st-upsell--empty">
      <p class="st-upsell__heading">Start tonight</p>
      <p class="st-upsell__sub">A calm, screen-free ritual — pick one to begin. No shipping · instant PDF.</p>
      <div class="st-upsell__cards">${cards}</div>
    </div>`;
    root.querySelectorAll('[data-st-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        try {
          await addVariant(btn.getAttribute('data-st-add'));
        } catch (e) {
          console.warn('[st-upsells] add failed', e);
          btn.disabled = false;
        }
      });
    });
  }

  function tonightOffers(set) {
    const offers = [];
    const hasDaily = set.has(HANDLES.daily);
    const hasNinjas = set.has(HANDLES.ninjas);
    const hasWizards = set.has(HANDLES.wizards);
    const hasBundle = set.has(HANDLES.bundle);
    if (hasBundle) return offers;

    const onlySkill = (hasNinjas || hasWizards) && !hasDaily;
    const teOnly = hasTeOnly({ items: [...set].map((h) => ({ handle: h })) });

    if (hasDaily) {
      if (!hasNinjas) offers.push(HANDLES.ninjas);
      if (!hasWizards) offers.push(HANDLES.wizards);
    } else if (onlySkill) {
      offers.push(HANDLES.daily);
      if (hasNinjas && !hasWizards) offers.push(HANDLES.wizards);
      if (hasWizards && !hasNinjas) offers.push(HANDLES.ninjas);
    } else if (teOnly) {
      offers.push(HANDLES.daily);
      offers.push(HANDLES.bundle);
    }
    return offers.filter((h) => !set.has(h));
  }

  function shouldShowUpgrade(set) {
    if (set.has(HANDLES.bundle)) return false;
    return [...COMPONENT_SET].some((h) => set.has(h));
  }

  function renderCartUpsells(cart) {
    injectStyles();
    const tonightRoot = document.querySelector('[data-st-cart-upsells]');
    const upgradeRoot = document.querySelector('[data-st-cart-upgrade]');
    if (!tonightRoot && !upgradeRoot) return;

    const set = handlesInCart(cart);
    const empty = !cart || !cart.item_count;

    if (tonightRoot) {
      if (empty || set.has(HANDLES.bundle)) {
        tonightRoot.innerHTML = '';
        tonightRoot.hidden = true;
      } else {
        const offers = tonightOffers(set);
        if (!offers.length) {
          tonightRoot.innerHTML = '';
          tonightRoot.hidden = true;
        } else {
          tonightRoot.hidden = false;
          const rows = offers
            .map((h) => {
              const p = cat(h);
              if (!p) return '';
              return `<div class="st-upsell__row">
                <div class="st-upsell__row-meta">
                  <div class="st-upsell__row-title">${p.title}</div>
                  <div class="st-upsell__row-price">${p.priceDisplay}</div>
                </div>
                <button type="button" class="st-upsell__btn st-upsell__btn--outline" data-st-add="${p.variantId}">Add</button>
              </div>`;
            })
            .join('');
          tonightRoot.innerHTML = `<div class="st-upsell st-upsell--cart">
            <p class="st-upsell__heading">Add for tonight</p>
            <p class="st-upsell__sub">Little extras that keep the screen-free rhythm going.</p>
            ${rows}
          </div>`;
          tonightRoot.querySelectorAll('[data-st-add]').forEach((btn) => {
            btn.addEventListener('click', async () => {
              btn.disabled = true;
              try {
                await addVariant(btn.getAttribute('data-st-add'));
              } catch (e) {
                console.warn('[st-upsells] add failed', e);
                btn.disabled = false;
              }
            });
          });
        }
      }
    }

    if (upgradeRoot) {
      if (empty || !shouldShowUpgrade(set)) {
        upgradeRoot.innerHTML = '';
        upgradeRoot.hidden = true;
      } else {
        upgradeRoot.hidden = false;
        const bundle = cat(HANDLES.bundle);
        upgradeRoot.innerHTML = `<div class="st-upsell st-upsell--upgrade">
          <p class="st-upsell__heading">Upgrade to Screen-Free Starter Bundle — ${bundle?.priceDisplay || '₹129'}</p>
          <p class="st-upsell__sub">Daily + Ninjas + Wizards together — save vs buying separately.</p>
          <button type="button" class="st-upsell__btn st-upsell__btn--outline" data-st-upgrade>Upgrade to Screen-Free Starter Bundle — ${bundle?.priceDisplay || '₹129'}</button>
        </div>`;
        const btn = upgradeRoot.querySelector('[data-st-upgrade]');
        btn?.addEventListener('click', async () => {
          btn.disabled = true;
          try {
            await upgradeToBundle();
          } catch (e) {
            console.warn('[st-upsells] upgrade failed', e);
            btn.disabled = false;
          }
        });
      }
    }
  }

  function renderPdpBumps() {
    const root = document.querySelector('[data-st-pdp-bumps]');
    if (!root) return;
    injectStyles();
    const handle = root.getAttribute('data-st-product-handle') || '';
    let html = '';

    if (handle === HANDLES.daily) {
      const n = cat(HANDLES.ninjas);
      const w = cat(HANDLES.wizards);
      html = `<div class="st-upsell st-upsell--pdp">
        <p class="st-upsell__heading">Add the matching pack for ₹49 — make tonight’s 10–15 minute session a little more complete.</p>
        ${n ? `<label class="st-upsell__check"><input type="checkbox" data-st-bump-vid="${n.variantId}"> Add Number Ninjas for ${n.priceDisplay}</label>` : ''}
        ${w ? `<label class="st-upsell__check"><input type="checkbox" data-st-bump-vid="${w.variantId}"> Add Word Wizards for ${w.priceDisplay}</label>` : ''}
      </div>`;
    } else if (handle === HANDLES.ninjas || handle === HANDLES.wizards) {
      const d = cat(HANDLES.daily);
      html = `<div class="st-upsell st-upsell--pdp">
        <p class="st-upsell__heading">Add Daily Practice for ₹99 — make tonight’s 10–15 minute session a little more complete.</p>
        ${d ? `<label class="st-upsell__check"><input type="checkbox" data-st-bump-vid="${d.variantId}"> Add Daily Practice for ${d.priceDisplay}</label>` : ''}
      </div>`;
    } else if (handle === HANDLES.bundle) {
      html = `<div class="st-upsell st-upsell--pdp">
        <p class="st-upsell__soft">Looking for themed packs? <a href="/collections/shop-all">Browse Theme Explorers</a>.</p>
      </div>`;
    } else if (handle === HANDLES.sample) {
      const d = cat(HANDLES.daily);
      html = `<div class="st-upsell st-upsell--pdp">
        <p class="st-upsell__soft">After you try it, <a href="${d?.url || '/products/daily-practice-screen-free-10-day'}">Daily Practice is ${d?.priceDisplay || '₹99'}</a>.</p>
      </div>`;
    } else {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    root.innerHTML = html;
  }

  function collectCheckedBumps(form) {
    const scope = form?.closest('product-form-component') || form || document;
    const boxes = scope.querySelectorAll('[data-st-bump-vid]:checked');
    return [...boxes].map((b) => Number(b.getAttribute('data-st-bump-vid'))).filter(Boolean);
  }

  async function addPendingBumps() {
    if (bumpInFlight || !pendingBumpIds.length) return;
    bumpInFlight = true;
    const ids = [...pendingBumpIds];
    pendingBumpIds = [];
    try {
      for (const id of ids) {
        // Skip if already in cart
        const cart = cartCache || (await fetchCart());
        const already = (cart.items || []).some((it) => Number(it.variant_id || it.id) === Number(id));
        if (already) continue;
        await addVariant(id, { open: true });
      }
    } catch (e) {
      console.warn('[st-upsells] bump add failed', e);
    } finally {
      bumpInFlight = false;
    }
  }

  function wirePdpAtc() {
    document.addEventListener(
      'click',
      (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        const btn = t.closest('button[type="submit"][name="add"], button[name="add"], [data-add-to-cart], .add-to-cart-button, button[type="submit"]');
        if (!btn) return;
        const form = btn.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
        if (!form) return;
        // Only when bumps mount exists nearby
        const bumps = document.querySelector('[data-st-pdp-bumps]');
        if (!bumps || bumps.hidden) return;
        const ids = collectCheckedBumps(form);
        if (ids.length) {
          pendingBumpIds = ids;
          // Fallback watcher if cart event is slow/missed
          const startCount = cartCache?.item_count ?? null;
          const started = Date.now();
          const poll = async () => {
            if (!pendingBumpIds.length) return;
            try {
              const c = await fetchCart();
              if (startCount == null || c.item_count > startCount) {
                await addPendingBumps();
                return;
              }
            } catch (_) {}
            if (Date.now() - started < 8000) setTimeout(poll, 400);
          };
          setTimeout(poll, 600);
        }
      },
      true
    );
  }

  function renderAll(cart) {
    if (!readConfig()) return;
    document.querySelectorAll('[data-st-empty-cards]').forEach((el) => renderEmptyCards(el, cart));
    renderCartUpsells(cart);
    renderPdpBumps();
  }

  function onCartUpdate() {
    fetchCart()
      .then((c) => {
        renderAll(c);
        if (pendingBumpIds.length) addPendingBumps();
      })
      .catch(() => {});
  }

  function init() {
    if (!readConfig()) {
      // Config may load later via section morph — retry briefly
      setTimeout(() => {
        if (readConfig()) init();
      }, 300);
      return;
    }
    injectStyles();
    wirePdpAtc();
    document.addEventListener(CART_EVENT, onCartUpdate);
    fetchCart()
      .then(renderAll)
      .catch(() => renderAll({ item_count: 0, items: [] }));

    // Re-render when cart drawer section is replaced (theme morph / our replaceWith)
    let reenter = false;
    let scheduled = null;
    const obs = new MutationObserver((mutations) => {
      if (reenter) return;
      let relevant = false;
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (!(n instanceof Element)) continue;
          if (
            n.id === `shopify-section-${SECTION_ID}` ||
            n.querySelector?.(`[data-st-empty-cards], [data-st-cart-upsells], [data-st-cart-upgrade], [data-st-pdp-bumps]`) ||
            n.matches?.(`[data-st-empty-cards], [data-st-cart-upsells], [data-st-cart-upgrade], [data-st-pdp-bumps]`)
          ) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }
      if (!relevant) return;
      if (scheduled) cancelAnimationFrame(scheduled);
      scheduled = requestAnimationFrame(() => {
        scheduled = null;
        reenter = true;
        try {
          renderAll(cartCache || { item_count: 0, items: [] });
        } finally {
          reenter = false;
        }
      });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
